'use strict';

var define = require('define-properties');
var getPolyfill = require('./polyfill');

module.exports = function shimForEach() {
	var polyfill = getPolyfill();
	define(
		Array.prototype,
		{ forEach: polyfill },
		{ forEach: function () { return Array.prototype.forEach !== polyfill; } }
	);
	return polyfill;
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.foreach/shim.js
// module id = W+CV
// module chunks = 78